import React from 'react'
import "../Assets/styles/team.css"
import team1 from "../Assets/images/mybanner.png";
import team2 from "../Assets/images/team2.jpg";
import team3 from "../Assets/images/malik.jpg"

const Teamer = () => {
  return (
    <div>
        <div className='container-lg wow'>
          <h1>Our Expert Team</h1>
          <div className='row'>
            <div className='col-lg-4 col-md-6 cad'>
              <img src={team3} alt='fhfj'/>
            <div className='sec'>
            <h2>Amzat AbdulMalik</h2>
            <p>FullStack Developer</p>
            </div>
            </div>
            <div className='col-lg-4 col-md-6 cad'>
              <img src={team2} alt='23'/>
              <div className='sec'>
              <h2>Adeniyi Abideen</h2>
              <p>Product Designer</p>
              </div>
            </div>
            <div className='col-lg-4 col-md-6 cad'>
              <img src={team1} alt='23'/>
              <div className='sec'>
              <h2>Bayode Gabriel</h2>
              <p>FullStack Developer</p>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Teamer